import ReactGA from "react-ga4";

export const initializeGA = () => {
    ReactGA.initialize("G-B66SXMZYSN"); // Replace with your GA4 Measurement ID
};

export const trackPageView = (path) => {
    ReactGA.send({ hitType: "pageview", page: path });
};

export const trackEvent = (event, data) => {
    ReactGA.event(event, data);
};

export const identifyUser = (userId, accountId, accountName) => {
    // Setting user ID
    ReactGA.set({ user_id: userId });

    // Sending custom user properties (GA4 way)
    ReactGA.set({
        user_properties: {
            account_id: accountId,
            account_name: accountName,
            caa_user_id: userId,
        },
    });
};
